import { useState } from 'react';
import { acceptAll, hasMadeChoice, rejectNonEssential } from '../utils/consent.js';
import { consentRequiredHere, gpcEnabled } from '../utils/geo.js';

// Ad landing pages carry a cookie banner only where one is legally required.
// Outside the EU/EEA/UK/CH the regime is opt-out, not opt-in, so a visitor who
// lands from an ad gets an uninterrupted page and we get working Pixel/Ads
// attribution — which is the entire point of a paid landing page. Inside those
// regions nothing changes: the banner shows and no tracker loads until it is
// answered.
//
// Deliberately NOT an effect. CookieBanner opens itself on mount, so deciding
// one tick later means a banner that flashes up and vanishes on every US
// visit. localStorage and Intl are both synchronous, so the decision is made
// during the first render instead, via a lazy useState initializer. The write
// to localStorage inside it is a side effect in render, which is the reason
// this lives in one documented place rather than being sprinkled around;
// React may invoke it twice in StrictMode and both calls are idempotent.
//
// Returns nothing to render against — CookieBanner reads the stored choice
// itself. A visitor who was auto-granted can still change their mind: the
// legal strip at the foot of the landing page reopens the banner.
export default function useLandingConsent(enabled) {
  useState(() => {
    if (!enabled || typeof window === 'undefined') return null;
    if (hasMadeChoice()) return null; // returning visitor: their choice stands
    if (consentRequiredHere()) return null; // banner must be answered first
    if (gpcEnabled()) rejectNonEssential(); // honor the browser opt-out signal
    else acceptAll();
    return null;
  });
}
